/**
 * @generated SignedSource<<5ce3d3055736f9bf7f5025d169b7c628>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type VisibilityStatus = "ALL" | "NONE" | "QUALIFYING";
import { FragmentRefs } from "relay-runtime";
export type useGetGolfPlayerRateOptions_Booking$data = {
  readonly startSlot: {
    readonly agenda: {
      readonly facility: {
        readonly club: {
          readonly supportsPrivate: boolean;
        } | null | undefined;
      };
    };
    readonly filteredPlayerRates?: ReadonlyArray<{
      readonly eighteenHolePrice: number | null | undefined;
      readonly nineHolePrice: number | null | undefined;
      readonly rate: {
        readonly appliesToMembershipType: boolean | null | undefined;
        readonly id: string;
        readonly name: string;
        readonly visibility: VisibilityStatus;
      };
    } | null | undefined> | null | undefined;
    readonly id: string;
  } | null | undefined;
  readonly " $fragmentType": "useGetGolfPlayerRateOptions_Booking";
};
export type useGetGolfPlayerRateOptions_Booking$key = {
  readonly " $data"?: useGetGolfPlayerRateOptions_Booking$data;
  readonly " $fragmentSpreads": FragmentRefs<"useGetGolfPlayerRateOptions_Booking">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "membershipTypeId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "useGetGolfPlayerRateOptions_Booking",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "startSlot",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Agenda",
          "kind": "LinkedField",
          "name": "agenda",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Facility",
              "kind": "LinkedField",
              "name": "facility",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Club",
                  "kind": "LinkedField",
                  "name": "club",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "supportsPrivate",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": "filteredPlayerRates",
              "args": [
                {
                  "kind": "Literal",
                  "name": "type",
                  "value": "CUSTOMER"
                },
                {
                  "kind": "Variable",
                  "name": "visibleToMembershipTypeId",
                  "variableName": "membershipTypeId"
                }
              ],
              "concreteType": "SlotRate",
              "kind": "LinkedField",
              "name": "playerRates",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "rate",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "visibility",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": [
                        {
                          "kind": "Variable",
                          "name": "membershipTypeId",
                          "variableName": "membershipTypeId"
                        }
                      ],
                      "kind": "ScalarField",
                      "name": "appliesToMembershipType",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": "nineHolePrice",
                  "args": [
                    {
                      "kind": "Literal",
                      "name": "holeCount",
                      "value": "NINE"
                    }
                  ],
                  "kind": "ScalarField",
                  "name": "totalGolfPrice",
                  "storageKey": "totalGolfPrice(holeCount:\"NINE\")"
                },
                {
                  "alias": "eighteenHolePrice",
                  "args": [
                    {
                      "kind": "Literal",
                      "name": "holeCount",
                      "value": "EIGHTEEN"
                    }
                  ],
                  "kind": "ScalarField",
                  "name": "totalGolfPrice",
                  "storageKey": "totalGolfPrice(holeCount:\"EIGHTEEN\")"
                }
              ],
              "storageKey": null
            }
          ],
          "type": "TimeSlot",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Booking",
  "abstractKey": "__isBooking"
};
})();

(node as any).hash = "b686f368a0c3e5a41c3a3a9516f1b424";

export default node;
